// import ArticleIcon from "@mui/icons-material/Article";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import { useState } from "react";

// const PageHeader = ({ banks = {}, title = "Aeps", selectedBank, setSelectedBank }) => {
//   const [open, setOpen] = useState(false);

//   // Convert banks object to array for iteration
//   const bankList = Object.keys(banks).map((key) => ({
//     label: key,
//     active: banks[key] === 1, // clickable if 1
//   }));

//   const handleBankClick = (bank) => {
//     if (!bank.active) return;
//     if (setSelectedBank) setSelectedBank(bank.label); // update parent
//     setOpen(false);
//   };

//   return (
//     <div className="mb-6 font-font w-full">
//       {/* Header Row */}
//       <div className="flex items-center justify-between w-full">
//         <h1 className="text-[10px] font-semibold text-[#1E2022] flex items-center gap-1 text-center">
//           {/* <ArticleIcon fontSize="small" />
//           */}
//           {title} 
//         </h1>

//         {/* Mobile Toggle */}
//         <button onClick={() => setOpen(!open)} className="md:hidden text-[#1E2022]">
//           {open ? <CloseIcon /> : <MenuIcon />}
//         </button>
//       </div>

//       {/* Desktop Menu */}
//       <div className="hidden md:flex mt-2 flex-wrap gap-4 text-[14px] text-[#334257]">
//         {bankList.map((bank) => (
//           <span
//             key={bank.label}
//             onClick={() => handleBankClick(bank)}
//             className={`cursor-pointer transition-colors duration-200 relative px-2 py-1 ${
//               bank.active
//                 ? "hover:text-[#005555]"
//                 : "text-gray-400 cursor-not-allowed"
//             } ${selectedBank === bank.label ? "text-[#005555] font-semibold" : ""}`}
//           >
//             {bank.label.toUpperCase()}
//             {/* bottom border for active bank */}
//             {selectedBank === bank.label && (
//               <span className="absolute bottom-0 left-0 w-full h-1 bg-[#005555] rounded-full"></span>
//             )}
//           </span>
//         ))}
//       </div>

//       {/* Mobile Menu */}
//       {open && (
//         <div className="md:hidden mt-3 flex flex-col gap-3 rounded-md border bg-white p-3 shadow">
//           {bankList.map((bank) => (
//             <span
//               key={bank.label}
//               onClick={() => handleBankClick(bank)}
//               className={`cursor-pointer text-[14px] relative ${
//                 bank.active
//                   ? ""
//                   : "text-gray-400 cursor-not-allowed"
//               } ${selectedBank === bank.label ? "text-[#005555] font-semibold" : ""}`}
//             >
//               {bank.label.toUpperCase()}
//               {selectedBank === bank.label && (
//                 <span className="absolute bottom-0 left-0 w-full h-1 bg-[#005555] rounded-full"></span>
//               )}
//             </span>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default PageHeader;




import { useState } from "react";

const PageHeader = ({ banks = {}, title = "Aeps", selectedBank, setSelectedBank }) => {
  const [open, setOpen] = useState(false);

  const bankList = Object.keys(banks).map((key) => ({
    label: key,
    active: banks[key] === 1,
  }));

  const handleBankClick = (bank) => {
    if (!bank.active) return;
    setSelectedBank(bank.label);
  
  };

return (
  <div className="w-full mb-6">
    {/* Title */}
    <div className="flex justify-center items-center relative w-full">
      <h1 className="text-[18px] md:text-[22px] font-bold text-[#1E2022] text-center">
        {title}
      </h1>
    </div>

    {/* Bank buttons (responsive grid) */}
    <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-3 mt-3">
      {bankList.map((bank) => (
        <button
          key={bank.label}
          onClick={() => handleBankClick(bank)}
          disabled={!bank.active}
          className={`px-3 py-2 rounded-md font-medium transition-colors text-center w-full ${
            bank.active
              ? selectedBank === bank.label
                ? "text-white bg-[#42a0ff]"
                : "text-[#334257] hover:text-[#005555] hover:bg-gray-100"
              : "text-gray-400 cursor-not-allowed"
          }`}
        >
          {bank.label.toUpperCase()}
        </button>
      ))}
    </div>
  </div>
);

};

export default PageHeader;
